import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-g01-icon-ranking" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isTop3)
      ? (_openBlock(), _createBlock(_component_IconBase, {
          key: 0,
          width: 32,
          height: 37,
          "view-box": "0 0 32 37"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon)))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
          key: 1,
          num: _ctx.num
        }, null, 8, ["num"]))
  ]))
}